export { default } from "./ShortcodesList"
